// Medición del recorrido de la home. Sin datos personales: solo identificadores de pantallas y opciones.
// Reglas en specs/home-conversacional/medicion-y-trazabilidad.md. Si algo falla, la charla sigue igual.

export const VERSION_FLUJO = '2026-10-24.1'; // sube con todo cambio de lo que la persona ve (2026-10-24.1: resultado con rumbo y frase)

const PERMITIDOS = new Set([
  'entrada', 'paso_visto', 'respuesta', 'texto_enviado', 'valor_visto', 'prompt_copiado',
  'resultado_visto', 'plan_abierto', 'contacto_abierto', 'contacto_enviado', 'contacto_error',
  'escribime_tocado', 'volver', 'reinicio', 'abandono', 'rumbo_visto', 'rumbo_compartido',
]);

const nuevoId = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : null);

let sesion = null;
export const sesionId = () => {
  if (sesion) return sesion;
  try {
    sesion = window.sessionStorage.getItem('guia_sesion');
    if (!sesion) { sesion = nuevoId(); if (sesion) window.sessionStorage.setItem('guia_sesion', sesion); }
  } catch { sesion = sesion || nuevoId(); }
  return sesion;
};

const dispositivo = () => {
  const w = window.innerWidth;
  return w < 640 ? 'movil' : w < 1024 ? 'tablet' : 'escritorio';
};

const cola = [];
let entradaEnviada = false;

const origenDeLaVisita = () => {
  try {
    const q = new URLSearchParams(window.location.search);
    let referente = '';
    try { referente = document.referrer ? new URL(document.referrer).hostname : ''; } catch {}
    return {
      utm_source: q.get('utm_source') || undefined,
      utm_medium: q.get('utm_medium') || undefined,
      utm_campaign: q.get('utm_campaign') || undefined,
      referente: referente || undefined,
    };
  } catch { return {}; }
};

export const vaciar = () => {
  if (!cola.length) return;
  const id = sesionId();
  if (!id) { cola.length = 0; return; }
  const cuerpo = JSON.stringify({
    sesion_id: id,
    version_flujo: VERSION_FLUJO,
    dispositivo: dispositivo(),
    ancho: window.innerWidth,
    ...origenDeLaVisita(),
    eventos: cola.splice(0, cola.length),
  });
  try {
    const ok = navigator.sendBeacon?.('/.netlify/functions/evento', new Blob([cuerpo], { type: 'application/json' }));
    if (!ok) fetch('/.netlify/functions/evento', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: cuerpo, keepalive: true }).catch(() => {});
  } catch {}
};

// datos: { pantalla, opcion, plan, valor } — nunca texto escrito por la persona.
export const evento = (nombre, datos = {}) => {
  try {
    if (!PERMITIDOS.has(nombre)) return;
    if (!entradaEnviada) { entradaEnviada = true; cola.push({ nombre: 'entrada', t: Date.now() }); }
    const { pantalla, opcion, plan, valor } = datos;
    cola.push({ nombre, pantalla, opcion, plan, valor, t: Date.now() });
    if (cola.length >= 6) vaciar();
  } catch {}
};

export const iniciarMedicion = () => {
  const alIrse = () => vaciar();
  window.addEventListener('pagehide', alIrse);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') vaciar(); });
  return () => window.removeEventListener('pagehide', alIrse);
};
